import { createFormState, required, validateWhen } from "redux-freeform";
import { ReduxFreeformField } from "../../types";

export type ClientFormConfig = {
  [key: string]: ReduxFreeformField;
};

export const clientsFormConfig: ClientFormConfig = {
  name: {
    defaultValue: "",
    validators: [required()],
  },
  brand: {
    defaultValue: "",
    validators: [required()],
  },
  slug: {
    defaultValue: "",
    validators: [required()],
  },
  credit_card_reader_type_id: {
    defaultValue: "",
    validators: [required()],
  },
  time_zone_id: {
    defaultValue: "",
    validators: [required()],
  },
  split_fee_text_default: {
    defaultValue: "",
    validators: [validateWhen(required(), required(), "split_fee_mid_default")],
  },
  split_fee_mid_default: {
    defaultValue: "",
    validators: [validateWhen(required(), required(), "split_fee_text_default")],
  },
};

export const {
  reducer: clientsFormReducer,
  mapStateToProps: clientsFormMapStateToProps,
  mapDispatchToProps: clientsFormMapDispatchToProps,
} = createFormState(clientsFormConfig);
